import { Component, HostListener } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/public/services/auth.service';
import { JWTTokenServiceService } from 'src/app/public/services/token.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { MessageService, SharedModule } from 'primeng/api';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MessageModule } from 'primeng/message';
import { InputTextModule } from 'primeng/inputtext';
import { FloatLabel } from 'primeng/floatlabel';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputOtpModule } from 'primeng/inputotp';
import { ToastModule } from 'primeng/toast';
import { SelectModule } from 'primeng/select';
@Component({
  selector: 'app-login',
  imports: [CommonModule, ReactiveFormsModule, FormsModule, MessageModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    InputTextModule,
    InputIconModule,
    IconFieldModule,
    InputOtpModule,
    SelectModule,
    ToastModule
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  providers: [MessageService]
})
export class LoginComponent {
  userName: any;
  btnLoading: boolean = false;
  isPasswordVisible: boolean = false;
  form: FormGroup = new FormGroup({
    username: new FormControl(''),
    password: new FormControl(''),
    environment: new FormControl(''),
  });
  submitted = false;
  isLoading = false;
  buttonTitle = "Login"
  otpForm: boolean = false;
  userOTP: any;
  loginData: any;
  constructor(private messageService: MessageService, private localStorageService: LocalStorageService, private coreAuth: AuthService, private router: Router, private formBuilder: FormBuilder, private jwt: JWTTokenServiceService) { }
  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.onEnter();
    }
  }

  selectedEnv: any = null;
  envList: any[] = [
    { name: 'Development', value: 'dev' },
    { name: 'Production', value: 'prod' },
  ]



  onEnter() {
    if (this.otpForm) {
      this.onOTPLogin();
    } else {
      this.onSubmit();
    }
  }
  ngOnInit(): void {
    this.form = this.formBuilder.group(
      {
        username: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(20)]],
        password: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(40)]],
        environment: ['', [Validators.required]],
      }
    );
  }


  forgetPassword() {
    this.router.navigate(['forget-password']);
  }
  goToDashboard() {
    this.router.navigate(['dashboard/home']);
  }


  get formError(): any {
    return this.form.controls;
  }
  onOTPLogin() {
    this.submitted = true;
    this.isLoading = true;
    this.buttonTitle = "Loading..."
    let param = {
      user_id: this.loginData.user_id,
      otp: this.userOTP,
      token: this.loginData.token

    }
    this.coreAuth.verifyOtp(param).subscribe({
      next: (res: any) => {
        if (res) {
          this.buttonTitle = "Login"
          this.isLoading = false;
          this.jwt.setToken(res.token);
          // this.toastr.success('Login Successful', 'Welcome');
          this.messageService.add({
            severity: 'success',
            summary: 'Login Successful',
            detail: 'Welcome'  // Similar to toastr.success
          });
          this.localStorageService.login(res);
          this.router.navigate(['main/clients']);
        }

      },
      error: (e) => {
        console.log(e);
        this.messageService.add({
          severity: 'error',
          summary: 'Invalid OTP',
          detail: 'Please enter correct OTP'  // Similar to toastr.error
        });
        this.buttonTitle = "Login"
        this.isLoading = false;
      },
      complete: () => {
        this.buttonTitle = "Login"
        this.isLoading = false;
      }
    })
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }
    this.isLoading = true;
    this.buttonTitle = "Loading..."
    this.coreAuth.loginUser(this.form.value).subscribe({
      next: (res: any) => {
        if (res) {
          console.log("res 123", this.form.value);
          localStorage.removeItem('environmentName');
          localStorage.removeItem('BASE_URL_A');
          localStorage.removeItem('BASE_URL_B');
          if (this.form.value.environment == 'dev') {
            localStorage.setItem('environmentName', 'dev');
            localStorage.setItem('BASE_URL_A', 'https://zbw3bnwar6.execute-api.us-east-1.amazonaws.com/dev/');
            localStorage.setItem('BASE_URL_B', 'https://7l3rsnlkak.execute-api.us-east-1.amazonaws.com/dev/');
            localStorage.setItem('BASE_URL_C', 'https://j92dsmz3nd.execute-api.us-east-1.amazonaws.com/dev/');
          }
          else if (this.form.value.environment == 'prod') {
            localStorage.setItem('environmentName', 'prod');
            localStorage.setItem('BASE_URL_A', 'https://xywfgrd3z1.execute-api.us-east-1.amazonaws.com/prod/');
            localStorage.setItem('BASE_URL_B', 'https://p3nj2i4q83.execute-api.us-east-1.amazonaws.com/prod/');
          }

          if (res.twoFactorAuthentication) {
            // this.toastr.success("OTP has been sent to your registered email ID. Please check your inbox.")
            this.messageService.add({
              severity: 'success',
              summary: 'OTP Sent',
              detail: 'OTP has been sent to your registered email ID. Please check your inbox.'  // Similar to toastr.success
            });
            this.otpForm = true;
            this.loginData = res;
          }
          else {
            console.log(" i a logged in");
            this.buttonTitle = "Login"
            this.isLoading = false;



            this.jwt.setToken(res.token);
            this.messageService.add({
              severity: 'success',
              summary: 'Login Successful',
              detail: 'Welcome'  // Similar to toastr.success
            });
            this.localStorageService.login(res);

            this.router.navigate(['main/clients']);

            // refresh the page
            window.location.reload();
          }

        }

      },
      error: (e) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Invalid Credentials',
          detail: 'Error'  // Similar to toastr.error
        });
        this.buttonTitle = "Login"
        this.isLoading = false;
      },
      complete: () => {
        this.buttonTitle = "Login"
        this.isLoading = false;
      }
    })
  }
  forgetPass() {
    this.router.navigate(['forget']);
  }
}
